import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { ColumnNote } from '../../../../models/locations-models/column-note';
import { getFromLocalStorage } from '../../../../core/utilities';
import { LocalStorageKeys } from '../../enums/local-storage-keys';
import { Location } from '../../../../models/locations-models/location';
import { LocationAddressTranslation } from '../../../../models/locations-models/location-address-translation';
import { ColumnState } from 'ag-grid-community';

export const locationsAdapter: EntityAdapter<Location> = createEntityAdapter<Location>();

export const addressTranslationsAdapter: EntityAdapter<LocationAddressTranslation> =
    createEntityAdapter<LocationAddressTranslation>();

export const columnNotesAdapter: EntityAdapter<ColumnNote> = createEntityAdapter<ColumnNote>({
  selectId: model => model.columnName, // unique ID
});

export const columnStateAdapter: EntityAdapter<ColumnState> = createEntityAdapter<ColumnState>({
  selectId: model => model.colId
});

export const getInitialColumnState = () => {
  const cachedColumnStateArr: ColumnState[] = getFromLocalStorage(LocalStorageKeys.COLUMN_STATE_KEY) ?
      getFromLocalStorage(LocalStorageKeys.COLUMN_STATE_KEY) : [];
  const stateObject = {ids: [], entities: {}};

  cachedColumnStateArr.forEach((col) => {
    stateObject.ids.push(col.colId);
    stateObject.entities[col.colId] = col;
  });

  const initialState = columnStateAdapter.setAll(cachedColumnStateArr, stateObject);
  return initialState;
}
